import { render } from "./LeaveMessageView.vue?vue&type=template&id=30f15881&scoped=true"
import script from "./LeaveMessageView.vue?vue&type=script&lang=js"
export * from "./LeaveMessageView.vue?vue&type=script&lang=js"

import "./LeaveMessageView.vue?vue&type=style&index=0&id=30f15881&lang=scss&scoped=true"

import exportComponent from "/root/workspace/fpcs-h5_ORUL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30f15881"]])

export default __exports__